import {Component, computed, inject, Signal, ChangeDetectionStrategy} from '@angular/core';
import {AppService} from '../../../services/app/app.service';
import {TranslateModule} from '@ngx-translate/core';
import {STATIC_CONFIGS} from '../../../../configs/static.config';
import {Logo} from '../../../types/logo.type';
import {IconComponent} from '../../icon/icon.component';
import {ICONS} from '../../../constants/icons/icons.constants';
import {LoadingSpinnerComponent} from '../../loading-spinner/loading-spinner.component';

@Component({
    host: { '[style.--splash-screen-background-image]': 'splashScreenBackgroundImage()' },
    selector: 'app-splash-screen',
    imports: [
        TranslateModule,
        IconComponent,
        LoadingSpinnerComponent
    ],
    templateUrl: './splash-screen.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './splash-screen.component.css'
})
export class SplashScreenComponent {
    protected readonly ICONS = ICONS;
    protected readonly splashScreenBackgroundImage: Signal<string | undefined>;
    protected readonly logo: Logo;
    private readonly appService = inject(AppService);
    
    public constructor() {
        this.logo = STATIC_CONFIGS.ui.defaultLoginLogo;
        this.splashScreenBackgroundImage = computed(() => 'url(' + this.appService.getBackgroundImageUrlSignal()() + ')');
    }
}
